module.exports = __webpack_public_path__ + "static/media/paymentInfo_blue.a2a328dc.svg";